'use client';

import { NavDock } from '@bomdisoft/components';
import { getLanguageFromLocale } from '@bomdisoft/translations';
import { navCookiePolicy, navDataDeletion, navGdpr, navSecurity, privacy, terms } from '@pieleaf/translations';
import { useParams } from 'next/navigation';

export const LegalNavDock = () => {
  const params = useParams();
  const langPrefix = typeof params.lang === 'string' ? params.lang : 'en';
  const language = getLanguageFromLocale(langPrefix);

  const items = [
    { href: `/${langPrefix}/privacy-policy`, label: privacy[language], matchPaths: [`/${langPrefix}/privacy-policy`], testId: 'legal-link-privacy' },
    { href: `/${langPrefix}/terms-of-service`, label: terms[language], matchPaths: [`/${langPrefix}/terms-of-service`], testId: 'legal-link-terms' },
    { href: `/${langPrefix}/security`, label: navSecurity[language], matchPaths: [`/${langPrefix}/security`], testId: 'legal-link-security' },
    { href: `/${langPrefix}/gdpr`, label: navGdpr[language], matchPaths: [`/${langPrefix}/gdpr`], testId: 'legal-link-gdpr' },
    { href: `/${langPrefix}/cookie-policy`, label: navCookiePolicy[language], matchPaths: [`/${langPrefix}/cookie-policy`], testId: 'legal-link-cookie-policy' },
    { href: `/${langPrefix}/data-deletion`, label: navDataDeletion[language], matchPaths: [`/${langPrefix}/data-deletion`], testId: 'legal-link-data-deletion' },
  ];

  return <NavDock items={items} testId='legal-nav-dock' />;
};
